import { useRef } from "react";
import { useDownloadExcel } from "react-export-table-to-excel";
import moment from 'moment';
import Swal from 'sweetalert2'




export default function ExportListData({time, location, data}) {
  const tableRef = useRef(null);
  const Toast = Swal.mixin({
    toast: true,
    position: "bottom-end",
    background:"#c51a1a",
    color:"#ffffff",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: `Electrical Data`,
    sheet: "Chemical Area"
  });

  let handleSubmit = () => {
    onDownload()
    
    Toast.fire({
      icon: "success",
      title: "Data has exported",
    });
  } 
  

  return (
    <div>
      <button hidden={data.length == 0} onClick={()=> handleSubmit()} className="btn bg-pallete text-white"><span className="fa fa-download mr-2" /> Export excel </button>

      <table ref={tableRef} style={{display:"none"}}>
        <tbody>
          <tr>
            <th colSpan="5" align="center">Electrical Data</th>
          </tr>
          <tr>
            <th colSpan="5"   align="center">Time Production : {time}</th>
          </tr>
          <tr>

          </tr>
          <tr>
            <th>No</th>
            <th>Date & Time</th>
            <th>Stage 1</th>
            <th>Stage 2</th>
            <th>Intake</th>
            <th>Jumlah KWH</th>
          </tr>
          {
            data !==0 && data.map((el, idx) =>  (
              <tr key={idx}>
                <td>{idx + 1}</td>
                <td width={200} align="left">{moment.utc(el.recorded_at).local().format('DD/MM/YYYY HH:mm:ss')}</td>
                <td width={200}>{el.stage_1}</td>
                <td width={200}>{el.stage_2}</td>
                <td width={200}>{el.intake}</td>
                <td width={200}>{el.total}</td>
              </tr>
            ))
          }
        </tbody>
      </table>
    </div>
  );
}
